module.exports = __webpack_public_path__ + "static/media/30OIOS9.212b5b17.jpg";